import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { Country, Region } from '@shared/generated'

import type { City } from '../model/types'

const GET_CITIES_QUERY = gql(`
  query GetCities {
    topology {
      countries {
        regions {
          cities {
            id
            name
            defaultShop {
              id
              address
              isPickupDeliveryAvailable
            }
          }
        }
      }
    }
  }
`)

export const useCities = () => {
  const { data, loading, error } = useQuery(GET_CITIES_QUERY, {
    fetchPolicy: 'cache-and-network',
  })

  const cities = useMemo<City[]>(() => {
    const { countries = [] } = data?.topology ?? {}
    const regions = countries.flatMap((country: Country) => country.regions ?? [])
    return regions.flatMap((region: Region) => region?.cities ?? [])
  }, [ data ])

  return {
    cities,
    data,
    loading,
    error,
  }
}
